angular.module('rjmNg.directives').directive "metricCohortOptions", [
  "timeRangeEnums"
  "reportBuilder"
  "dimensionService"
  "dateService"
  "Clients"
  "$routeParams"
  (
    timeRangeEnums
    reportBuilder
    dimensionService
    dateService
    Clients
    $routeParams
  ) ->
    restrict: "E"
    templateUrl: "directive.metricCohortOptions.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      metric: "="
      columns: "="
      interval: "="
      timeRange: "="
      addDimension: "="
      removeAllDimensions: "="
      groupByValues: "="
      updateReport: "="
      updateGroupByValues: "="
      # Allow press apply button for the first time after switching to cohort metic view,
      # then button enabled only if the user made changes
      switchedToCohortView: "="
      popover: "="
    controller: [
      "$scope"
      "rjqlStringConstants"
      (
        $scope
        rjqlStringConstants
      ) ->
        view = @

        CLIENT_ID = $routeParams.clientId
        BASE_PREVIEW_SIZE = 8
        MIN_PREVIEW_SIZE = BASE_PREVIEW_SIZE * 3
        INTERVAL_RJQL_TO_MOMENT =
          "Week": "weeks"
          "Month": "months"
          "Quarter": "quarters"
          "Year": "years"
        MAX_PREVIEW_SIZE =
          "Week": BASE_PREVIEW_SIZE * 80
          "Month": BASE_PREVIEW_SIZE * 80
          "Quarter": BASE_PREVIEW_SIZE * 30
          "Year": BASE_PREVIEW_SIZE * 7

        EMPTY_PREVIEW_TEXT_NO_BUCKETS = "Select cohort size to see a preview."
        EMPTY_PREVIEW_TEXT_TOO_MANY_BUCKETS = 'Preview not available. Click "Apply" to see the report.'

        view.DATE_COLUMN_TYPE = "DATETIME"
        view.dimensionIndex = 0
        view.newGroupByValues = {}

        view.search =
          cohortDimension: ""

        view.intervalsToShow = [
          timeRangeEnums.TIME_INTERVAL_VALUES.WEEK
          timeRangeEnums.TIME_INTERVAL_VALUES.MONTH
          timeRangeEnums.TIME_INTERVAL_VALUES.QUARTER
          timeRangeEnums.TIME_INTERVAL_VALUES.YEAR
        ]

        view.setCohortDimension = (dimension) ->
          view.selectedCohortDimension = dimension
          view.cohortDimensionChanged = view.metric.dimensions[0].column_id isnt view.selectedCohortDimension.column_id

        view.setTimeStampDimension = (dimension) ->
          view.selectedTimeStampDimension = dimension
          view.timeStampDimensionChanged = view.timeRange[1].field isnt view.selectedTimeStampDimension.column_id

        view.initialization = () ->
          view.allCohortDimensions = dimensionService.getAllCohortDimensions(
            view.metric.dimensionList,
            view.metric.timestampColumnId,
            view.columns
          )

          view.selectedCohortDimension = _.find(view.allCohortDimensions, (dimension) ->
            dimension.column_id is view.metric.dimensions[0].column_id)

          view.selectedTimeStampDimension = _.find(view.allCohortDimensions, (dimension) ->
            dimension.column_id is view.timeRange[1].field)

          view.cohortDimensionChanged = false
          view.timeStampDimensionChanged = false

          if dateService.isRangeMoving(view.timeRange[1])
            view.currentNumberOfMovingCohortBuckets = -(view.timeRange[1].start.value - view.timeRange[1].end.value)
            view.currentMinimumAmountOfDataForCohort = -view.timeRange[1].end.value
          else
            view.currentNumberOfMovingCohortBuckets = 12
            view.currentMinimumAmountOfDataForCohort = 1

          view.numberOfMovingCohortBuckets = view.currentNumberOfMovingCohortBuckets
          view.minimumAmountOfDataForCohort = view.currentMinimumAmountOfDataForCohort

          view.inputValid = true
          view.inputChanged = false

          view.generatePreviewCohortBuckets(true)

        _getTotalNumberOfCohortBuckets = () ->
          if not view.numberOfMovingCohortBuckets? or not view.minimumAmountOfDataForCohort?
            return 0
          else
            return view.minimumAmountOfDataForCohort + view.numberOfMovingCohortBuckets

        _createEmptyPreviewCohortBuckets = (interval, totalNumberOfCohortBuckets) ->
          if totalNumberOfCohortBuckets is 0
            view.emptyPreviewText = EMPTY_PREVIEW_TEXT_NO_BUCKETS
            view.previewCohortBuckets = []
          else if totalNumberOfCohortBuckets > MAX_PREVIEW_SIZE[interval]
             view.emptyPreviewText = EMPTY_PREVIEW_TEXT_TOO_MANY_BUCKETS
             view.previewCohortBuckets = []
          else
            if totalNumberOfCohortBuckets < MIN_PREVIEW_SIZE
              previewSize = MIN_PREVIEW_SIZE
            else if totalNumberOfCohortBuckets is MAX_PREVIEW_SIZE[interval]
              previewSize = MAX_PREVIEW_SIZE[interval]
            else
              previewSize = Math.floor(totalNumberOfCohortBuckets/BASE_PREVIEW_SIZE + 1) * BASE_PREVIEW_SIZE
            view.previewCohortBuckets = ({name: "", active: false} for i in [1..previewSize])

        _setPreviewCohortBucketsNames = (interval) ->
          unless view.previewCohortBuckets.length is 0
            initialDate = if interval is timeRangeEnums.TIME_INTERVAL_VALUES.WEEK then moment().day(view.momentWeekStartDay) else moment()
            date = initialDate.add(1, INTERVAL_RJQL_TO_MOMENT[interval])
            for preview in view.previewCohortBuckets
              preview.name = dateService.shortFormat(
                date.subtract(1, INTERVAL_RJQL_TO_MOMENT[interval]).format("YYYY-MM-DD")
                interval
                true
              )

        _setPreviewCohortBucketsActivity = (totalNumberOfCohortBuckets) ->
          for preview, i in view.previewCohortBuckets
            preview.active = i >= view.minimumAmountOfDataForCohort and i < totalNumberOfCohortBuckets

        view.generatePreviewCohortBuckets = (onInit=false, totalNumberOfCohortBuckets) ->
          interval = if onInit then view.interval else view.outputTimeInterval
          totalNumberOfCohortBuckets ?= _getTotalNumberOfCohortBuckets()
          _createEmptyPreviewCohortBuckets(interval, totalNumberOfCohortBuckets)
          _setPreviewCohortBucketsNames(interval)
          _setPreviewCohortBucketsActivity(totalNumberOfCohortBuckets)

        _updatePreviewCohorts = () ->
          totalNumberOfCohortBuckets = _getTotalNumberOfCohortBuckets()
          if totalNumberOfCohortBuckets is 0 or
            view.previewCohortBuckets.length is 0 or
            totalNumberOfCohortBuckets is MIN_PREVIEW_SIZE or
            (totalNumberOfCohortBuckets > MIN_PREVIEW_SIZE - BASE_PREVIEW_SIZE and
            totalNumberOfCohortBuckets < view.previewCohortBuckets.length - BASE_PREVIEW_SIZE) or
            totalNumberOfCohortBuckets >= view.previewCohortBuckets.length
              view.generatePreviewCohortBuckets(false, totalNumberOfCohortBuckets)
          else
            _setPreviewCohortBucketsActivity(totalNumberOfCohortBuckets)

        _percentToScroll = () ->
          lastActivePreviewCohortBucket = _.findLastIndex(view.previewCohortBuckets, {active: true})
          a = Math.ceil((lastActivePreviewCohortBucket + 1)/BASE_PREVIEW_SIZE*2)
          b = Math.ceil((view.previewCohortBuckets.length)/BASE_PREVIEW_SIZE*2)
          return (b-a)/b

        view.inputNgChange = () ->
          view.inputValid = view.numberOfMovingCohortBuckets? and view.minimumAmountOfDataForCohort?
          view.inputChanged = not (view.numberOfMovingCohortBuckets is view.currentNumberOfMovingCohortBuckets and
            view.minimumAmountOfDataForCohort is view.currentMinimumAmountOfDataForCohort)
          _updatePreviewCohorts()
          $scope.$broadcast("scrollToPercent", _percentToScroll())

        view.apply = () ->
          view.switchedToCohortView = false
          secondDimension = angular.copy(view.metric.dimensions[1])

          # Determine which grouping values we need to apply
          if view.appliedCohortDimensionIsTimeBased and
            not view.selectedCohortDimensionIsTimeBased
              tempGroupByValues = [angular.copy(view.newGroupByValues)[0]]
          else if not view.appliedCohortDimensionIsTimeBased and
            view.selectedCohortDimensionIsTimeBased
              tempGroupByValues = [{}]
          else
            tempGroupByValues = angular.copy(view.newGroupByValues)

          # Update dimension
          view.removeAllDimensions()
          view.addDimension(view.selectedCohortDimension, false, false)
          if secondDimension and view.selectedCohortDimensionIsTimeBased
            view.addDimension(secondDimension, false, false)
          view.updateGroupByValues(tempGroupByValues)


          # Check perspective and replace to standard if necessary
          if not view.selectedCohortDimensionIsTimeBased and
            view.metric.perspective in ['cumulativeAverageValuePerCohortMember', 'averageValuePerCohortMember']
              view.metric.perspective = 'standard'

          # Update metric
          if view.cohortDimensionChanged
            view.metric['counting-members'] = reportBuilder.getCountingMembers(view.metric, view.columns)

          tempTimeRange = [
              field: rjqlStringConstants.RJQL_TIME
              start:
                value: -(view.numberOfMovingCohortBuckets + view.minimumAmountOfDataForCohort)
                type: timeRangeEnums.RANGE_TYPES.MOVING
                unit: view.outputTimeInterval
              end:
                value: 0
                type: timeRangeEnums.RANGE_TYPES.MOVING
                unit: view.outputTimeInterval
            ,
              field: if view.selectedCohortDimensionIsTimeBased then view.selectedCohortDimension.column_id else view.selectedTimeStampDimension.column_id
              start:
                value: -(view.numberOfMovingCohortBuckets + view.minimumAmountOfDataForCohort)
                type: timeRangeEnums.RANGE_TYPES.MOVING
                unit: view.outputTimeInterval
              end:
                value: -view.minimumAmountOfDataForCohort
                type: timeRangeEnums.RANGE_TYPES.MOVING
                unit: view.outputTimeInterval
          ]

          # Updating of time ranges and time interval:
          if view.selectedCohortDimensionIsTimeBased
            # If interval or timerange hasn't been changed then we have to call
            # updateReport() directly
            if view.interval is view.outputTimeInterval and
              angular.equals(view.timeRange, tempTimeRange)
                view.updateReport?()
            # Otherwise, updateReport() will be called by the watcher("view.time")
            # in visualReportBuilderDirective
            else
              view.interval = view.outputTimeInterval
              view.timeRange = tempTimeRange
          # If cohort dimension isn't time-based then we need to update only "field"
          # value in the second timerange. Other time settings should be set in
          # time settings popover.
          else
            # If timerange field has been changed then updateReport() will be called
            # by the watcher("view.time") in visualReportBuilderDirective
            if view.timeRange[1]?.field isnt tempTimeRange[1].field
              view.timeRange[1].field = tempTimeRange[1].field
            # Otherwise, we should call updateReport() directly
            else
              view.updateReport?()

          view.popover.hide()

        view.cancel = () ->
          view.popover.hide()


        view.$onInit = () ->
          view.loading = true
          Clients.get(CLIENT_ID).then(
            (clientInfo) ->
              # Convert rjm week start day to moment.js:
              # moment.js: Sunday -> Saturday: 0 1 2 3 4 5 6
              # rjm:       Sunday -> Saturday: 7 1 2 3 4 5 6
              view.momentWeekStartDay = clientInfo.properties.week_start_day%7
              view.initialization()
              view.loading = false
          )

        view
    ]
    link: (scope, element, attr, view) ->
      scope.$watch('view.outputTimeInterval', (newTimeInterval, oldTimeInterval) ->
        if newTimeInterval isnt oldTimeInterval and oldTimeInterval?
          view.generatePreviewCohortBuckets(false)
      )

      scope.$watch('view.selectedCohortDimension.datatype', (newType, oldType) ->
        if newType is view.DATE_COLUMN_TYPE
          view.selectedCohortDimensionIsTimeBased = true
          scope.$broadcast("scrollToBottom")
        else
          view.selectedCohortDimensionIsTimeBased = false
      , true
      )

      scope.$watch('view.metric.dimensions[0].datatype', (newType, oldType) ->
        if newType is view.DATE_COLUMN_TYPE
          view.appliedCohortDimensionIsTimeBased = true
        else
          view.appliedCohortDimensionIsTimeBased = false
      , true
      )

      scope.$watch('view.timeRange', (newTimeRange, oldTimeRange) ->
        view.initialization()
      , true
      )

      scope.$watch('view.popover.visible', (visible, old) ->
        if visible isnt old and not visible
          view.initialization()
          scope.$broadcast("initializeInterval")
      )
]
